var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-85 0 512 512",
    width: "512pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m320 192h-126.675781l19.921875-168.148438c.066406-.40625.085937-2.089843.085937-2.519531 0-11.964843-9.363281-21.332031-21.332031-21.332031-6.675781 0-13.078125 3.179688-17.40625 9.023438l-170.328125 255.511718c-2.75 3.667969-4.265625 8.210938-4.265625 12.796875 0 11.96875 9.367188 21.335938 21.332031 21.335938h105.472657l-20.074219 189.800781c-.042969.382812-.0625 1.8125-.0625 2.199219 0 11.964843 9.363281 21.332031 21.332031 21.332031 6.675781 0 13.078125-3.179688 17.300781-8.875l191.765625-276.992188c2.753906-3.667968 4.265625-8.210937 4.265625-12.800781 0-11.964843-9.363281-21.332031-21.332031-21.332031zm0 0",
    fill: "#ffc107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.05031992b1a834f1a3e04c4ed23889d1.svg";
export { ForwardRef as ReactComponent };